import { Observable } from '@microsoft/fast-element';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Need it to get webcomponents working with mobx
import { reaction } from 'mobx';

const propertyMap = new Map<any, string[]>();

export function mobxObservableProperty(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
): void {
    // Record the constructor/property name
    const classConfig = propertyMap.get(target.constructor) ?? [];
    propertyMap.set(target.constructor, classConfig);
    classConfig.push(propertyKey);

    // Set up records for this constructor/property
    const originalGet = descriptor.get;

    descriptor.get = function (this: any) {
        Observable.track(this, propertyKey);
        return originalGet?.call(this);
    };
}

type Consturctor = {
    new (...args: any[]): any;
};
export function mobxObserver<T extends Consturctor>(BaseClass: T): T {
    return class extends BaseClass {
        #reactionDisposers: (() => void)[] = [];

        connectedCallback() {
            super.connectedCallback?.();
            for (const propertyKey of propertyMap.get(BaseClass) ?? []) {
                this.#reactionDisposers.push(
                    reaction(
                        () => this[propertyKey],
                        () => Observable.notify(this, propertyKey)
                    )
                );
            }
        }

        disconnectedCallback() {
            super.disconnectedCallback?.();
            for (const disposer of this.#reactionDisposers) {
                disposer();
            }
        }
    };
}
